import React from 'react'
import { FormGroup, Label, Input } from 'reactstrap'

const pageSizeOptions = [4, 8, 16, 32]

function InstancesPageSizeSelect({ pageSize, onPageSizeChange }) {
  return (
    <FormGroup className="page-size-control">
      <Label for="pageSize" className="page-size-label">
        Instancias por página
      </Label>
      <Input
        type="select"
        name="pageSize"
        id="pageSize"
        className="page-size-select"
        value={pageSize}
        onChange={(event) => onPageSizeChange(Number(event.target.value))}
      >
        {pageSizeOptions.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </Input>
    </FormGroup>
  )
}

export default InstancesPageSizeSelect